import React, { useEffect, useState } from "react";
import { creators } from "./CreatorGallery";

export const CreatorCard = ({ creator }) => {
  return (
    <div className="relative min-w-[230px] p-2 bg-white rounded-xl overflow-hidden shadow-sm group transition-all duration-300 hover:shadow-md">
      <div className="aspect-[9/16] w-full bg-gray-200 rounded-xl relative overflow-hidden">
        <video
          src={creator.videoUrl}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
          autoPlay
          muted
          playsInline
          loop
          preload="metadata"
        />
        <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded-full z-20">
          {creator.category}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 z-20">
          <div className="text-white">
            <h3 className="font-semibold text-sm md:text-base">
              {creator.name}
            </h3>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between p-2 pt-4 bg-white rounded-b-xl">
        <div className="flex items-center gap-2">
          {/* <img src={creator.creatorImgUrl} alt={creator.creatorName} className="h-10 w-10 rounded-full"/> */}
          <span className="text-sm font-medium text-black">
            {creator.creatorName}
          </span>
        </div>
        <div>
          <span className="text-sm text-gray-500 ml-2">
            {creator.creatorRating ? `${creator.creatorRating} ⭐` : ""}
          </span>
        </div>
      </div>
    </div>
  );
};

const InfiniteScrollVideo = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const animation = setInterval(() => {
      setScrollPosition((prev) => {
        const newPosition = prev - 0.2; 
        if (newPosition < -100) {
          return 0;
        }
        return newPosition;
      });
    }, 20);

    return () => clearInterval(animation);
  }, []);

  return (
    <div className="relative w-full overflow-hidden">
      <div 
        className="flex gap-1 md:gap-2 animate-scroll"
        style={{
          transform: `translateX(${scrollPosition}%)`,
          transition: 'transform 0.02s linear',
        }}
      >
        {[...creators, ...creators].map((creator, index) => (
          <CreatorCard 
            key={`${creator.id}-${index}`} 
            creator={creator} 
          />
        ))}
      </div>
    </div>
  );
};

export default InfiniteScrollVideo;
